// <s-card-swipe> lets shoppers swipe through a product card's photos on collection pages.
// Cues: dots on the photo show there is more; the first card on the page nudges sideways once per visit.
class CardSwipe extends HTMLElement {
  #track = null;
  #dots = [];
  #frame = 0;

  connectedCallback() {
    this.#track = this.querySelector("[data-card-track]");
    this.#dots = [...this.querySelectorAll("[data-card-dot]")];
    if (!this.#track || this.#dots.length < 2) return;
    this.#track.addEventListener("scroll", this.#onScroll, { passive: true });
    if (this.hasAttribute("data-nudge")) this.#nudge();
  }

  disconnectedCallback() {
    this.#track?.removeEventListener("scroll", this.#onScroll);
  }

  #onScroll = () => {
    cancelAnimationFrame(this.#frame);
    this.#frame = requestAnimationFrame(() => {
      const index = Math.round(this.#track.scrollLeft / this.#track.clientWidth);
      this.#dots.forEach((dot, i) => dot.classList.toggle("opacity-100", i === index));
      this.#dots.forEach((dot, i) => dot.classList.toggle("opacity-50", i !== index));
    });
  };

  #nudge() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    try {
      if (sessionStorage.getItem("lachi-card-nudge")) return;
    } catch {}
    const observer = new IntersectionObserver((entries) => {
      if (!entries[0]?.isIntersecting) return;
      observer.disconnect();
      setTimeout(() => {
        const distance = Math.round(this.#track.clientWidth * 0.28);
        this.#track.style.scrollSnapType = "none";
        this.#track.scrollTo({ left: distance, behavior: "smooth" });
        setTimeout(() => {
          this.#track.scrollTo({ left: 0, behavior: "smooth" });
          setTimeout(() => (this.#track.style.scrollSnapType = ""), 500);
        }, 650);
        try {
          sessionStorage.setItem("lachi-card-nudge", "1");
        } catch {}
      }, 900);
    }, { threshold: 0.6 });
    observer.observe(this);
  }
}

if (!customElements.get("s-card-swipe")) customElements.define("s-card-swipe", CardSwipe);
